import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import Flickity from 'react-flickity-component';
import MediaQuery from 'react-responsive';

import Button from '../../Button';
import Paragraph from '../../Paragraph';
import Heading from '../../Heading';
import { renderField } from '../../Inputs';
import { Row } from '../../Register/Scaffold';
import Progress from '../../Progress';

import pintImg from '../../../images/pint.svg';
import beerBottleImg from '../../../images/beer-bottle.svg';
import smallWineImg from '../../../images/wine-small.svg';
import largeWineImg from '../../../images/wine-large.svg';
import bottleWineImg from '../../../images/wine-bottle.svg';
import shotImg from '../../../images/shot.svg';

const required = value => (value || typeof value === 'number' ? undefined : 'Required');
const number = value => (value && isNaN(Number(value)) ? 'Must be a number' : undefined);

const parsers = {
  number: (value) => {
    let result;
    if (new RegExp(/^\d*$/g).test(value) && !(value.indexOf('.') > -1) && value.length > 3) {
      result = parseInt(value.substring(0, 3), 10) <= 999 ? value.substring(0, 3) : '';
    }

    if (value) {
      return new RegExp(/^([0-9]|[1-9][0-9]|[1-9][0-9][0-9])$/g).test(value) ? value : result;
    }
    return '';
  },
};

const aboveZero = (value) => {
  if (value < 0) {
    return 0;
  }
  return value;
};

const carouselOpts = {
    wrapAround: false,
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    prevNextButtons: false,
    // watchCSS: true,
    imagesLoaded: true,
};

class CurrentAlcohol extends React.PureComponent {
  componentDidMount() {

  }

  render() {
    const { prevPage, handleSubmit } = this.props;

    return (
      <Row classes="drinking-less">
        <Progress step="alcohol" />
        <Paragraph classes="images" center>
          <img src="https://livewelldorset.s3.amazonaws.com/Pathways/drink-less.png" alt="" width="100" height="100" />
        </Paragraph>
        {/* <Heading classes="header-text yellow" center><span id="register8">Drink less</span></Heading> */}
        <Heading tag="h3" classes="header-text units-guide-title" center>Unit guide</Heading>
        <MediaQuery minWidth={769}>
          {(matches) => {
            const Component = matches ? 'div' : Flickity;

            return (
              <Component className="units-guide-carousel" options={carouselOpts} static>
                <div key={0} className="carousel-item">
                  <Paragraph classes="unit-type">Pint of <br /> Beer / Cider</Paragraph>
                  <img src={pintImg} alt="small wine" width="52" height="140" />
                  <Paragraph classes="unit-amount">2.2 units</Paragraph>
                </div>
                <div key={1} className="carousel-item">
                  <Paragraph classes="unit-type">Bottle of <br /> Beer / Cider</Paragraph>
                  <img src={beerBottleImg} alt="small wine" width="52" height="140" />
                  <Paragraph classes="unit-amount">1.5 units</Paragraph>
                </div>
                <div key={2} className="carousel-item">
                  <Paragraph classes="unit-type">Small Glass of <br /> Wine</Paragraph>
                  <img src={smallWineImg} alt="small wine" width="52" height="140" />
                  <Paragraph classes="unit-amount">2.2 units</Paragraph>
                </div>
                <div key={3} className="carousel-item">
                  <Paragraph classes="unit-type">Large Glass of <br /> Wine</Paragraph>
                  <img src={largeWineImg} alt="small wine" width="52" height="140" />
                  <Paragraph classes="unit-amount">3 units</Paragraph>
                </div>
                <div key={4} className="carousel-item">
                  <Paragraph classes="unit-type">Bottle of <br /> Wine</Paragraph>
                  <img src={bottleWineImg} alt="small wine" width="52" height="140" />
                  <Paragraph classes="unit-amount">9.8 units</Paragraph>
                </div>
                <div key={5} className="carousel-item">
                  <Paragraph classes="unit-type">Shot of <br /> Spirit</Paragraph>
                  <img src={shotImg} alt="small wine" width="52" height="140" />
                  <Paragraph classes="unit-amount">1 unit</Paragraph>
                </div>
              </Component>
            );
          }}
        </MediaQuery>
        <form onSubmit={handleSubmit} className="form-register">
          <Paragraph classes="section-text alcohol-unit-section" center><strong>Roughly how many units of alcohol do you currently drink each week?</strong></Paragraph>
          <Field
            name="drinking"
            type="text"
            component={renderField}
            validate={[required, number]}
            centered
            normalize={aboveZero}
            parse={parsers.number}
            classes="text-input-field"
          />

          <Paragraph classes="button-groups divideline" center>
            <Button classes={['color-button yellow']} label="Next" onClick={handleSubmit} />
            <Button classes={['underline-button']} label="Back" onClick={prevPage} />
          </Paragraph>
        </form>
      </Row>
    );
  }
}

CurrentAlcohol.propTypes = {
  prevPage: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'assessment', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(CurrentAlcohol);



// WEBPACK FOOTER //
// ./src/Components/Assessment/Pages/CurrentAlcohol.jsx